import React, { useState, useEffect, useContext } from 'react';
import {
  Container,
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
} from '@mui/material';
import { AppContext } from '../../core/Contexts/AppContext';
import { sendApplication } from '../../core/services/send-application';
import { getFilterOptions } from '../../core/services';
import { useNavigate } from 'react-router-dom';

import Step1 from '../../component/AdpSteps/Step-1';
import Step2 from '../../component/AdpSteps/Step-2';
import Step3 from '../../component/AdpSteps/Step-3';
import Step4 from '../../component/AdpSteps/Step-4';
import Step5 from '../../component/AdpSteps/Step-5';

const steps = [
  'ნაბიჯი 1 (სიტუაციის აღწერა)',
  'ნაბიჯი 2 (პროდუქტის აღწერა)',
  'ნაბიჯი 3 (დაზარალებული მონაცემები)',
  'ნაბიჯი 4 (განმცხადებლის მონაცემები)',
  'ნაბიჯი 5 (დადასტურება, გაგზავნა)',
];

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '20px',
  },
  modal: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
  },
  text: {
    fontSize: '18px',
    margin: '0 0 20px 0',
    lineHeight: '1.4',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#007bff',
    color: '#fff',
    cursor: 'pointer',
  },
};

const MultiStepForm = () => {
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);
  const navigate = useNavigate();

  // Set header details
  setTitle('განაცხადე საფრთხის შემცველ პროდუქტებზე');
  setImage('../../images/hero-images/pattern-bg-optimized.jpg');
  setHeaderType(1);

  const [filtersOptions, setFiltersOptions] = useState({ categories: [] });
  useEffect(() => {
    getFilterOptions()
      .then((options) => setFiltersOptions(options))
      .catch((error) => console.error('Error fetching filter options:', error));
  }, []);

  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    userType: '',
    productCategory: '',
    incidentDescription: '',
    productionDate: null,
    productDescription: '',
    city: '',
    organization: '',
    productRiskDate: null,
    selectedValue: 'no',
    productName: '',
    brandName: '',
    firstName: '',
    lastName: '',
    personAge: '',
    personFirstName: '',
    personLastName: '',
    personEmail: '',
    personPhone: '',
    personAddress: '',
    email: '',
    phone: '',
    address: '',
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('');

  const validateStep = () => {
    let newErrors = {};
    if (activeStep === 0) {
      if (!formData.userType) newErrors.userType = 'ეს ველი სავალდებულოა';
      if (!formData.incidentDescription)
        newErrors.incidentDescription = 'გთხოვთ შეიყვანოთ აღწერა';
    }
    if (activeStep === 1) {
      if (!formData.productName)
        newErrors.productName = 'პროდუქტის დასახელება აუცილებელია';
      if (!formData.productDescription)
        newErrors.productDescription = 'გთხოვთ შეიყვანოთ პროდუქტის აღწერა';
    }
    if (activeStep === 3) {
      if (!formData.firstName) newErrors.firstName = 'სახელი სავალდებულოა';
      if (!formData.lastName) newErrors.lastName = 'გვარი სავალდებულოა';
      if (!formData.email) newErrors.email = 'ელ-ფოსტა სავალდებულოა';
      if (!formData.phone) newErrors.phone = 'ტელეფონი სავალდებულოა';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  // Submit function to send the application and set status based on response
  const handleSubmit = async () => {
    try {
      const response = await sendApplication(formData);
      if (response.status === 200) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error submitting application:', error);
      setStatus('error');
    }
  };

  const handleModalClose = () => {
    setStatus('');
    navigate('/');
  };

  return (
    <Container maxWidth='lg' className='mt-25'>
      <Box display='flex' flexDirection={{ xs: 'column', md: 'row' }}>
        <Box width={{ xs: '100%', md: '30%' }}>
          <Stepper activeStep={activeStep} orientation='vertical'>
            {steps.map((label, index) => {
              const stepText = label.split(' (')[0];
              const stepDetails = label.split(' (')[1]?.slice(0, -1);
              return (
                <Step key={index}>
                  <StepLabel>
                    <div>
                      <span>{stepText}</span>
                    </div>
                    {stepDetails && (
                      <div
                        style={{
                          marginTop: '4px',
                          fontSize: '0.875rem',
                          color: '#6c757d',
                        }}
                      >
                        {stepDetails}
                      </div>
                    )}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </Box>
        <Box width={{ xs: '100%', md: '70%' }} p={3}>
          {activeStep === 0 && (
            <Step1
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
            />
          )}
          {activeStep === 1 && (
            <Step2
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              filtersOptions={filtersOptions}
            />
          )}
          {activeStep === 2 && (
            <Step3
              formData={formData}
              setFormData={setFormData}
              setErrors={setErrors}
            />
          )}
          {activeStep === 3 && (
            <Step4
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
            />
          )}
          {activeStep === 4 && (
            <Step5 formData={formData} filtersOptions={filtersOptions} />
          )}
          <Box display='flex' justifyContent='space-between' mt={2}>
            <Button
              variant='contained'
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              უკან
            </Button>
            <Button
              variant='contained'
              onClick={
                activeStep === steps.length - 1 ? handleSubmit : handleNext
              }
            >
              {activeStep === steps.length - 1 ? 'გაგზავნა' : 'შემდეგი'}
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Modal Popup for Success */}
      {status === 'success' && (
        <Box sx={modalStyles.overlay}>
          <Box sx={modalStyles.modal}>
            <Typography sx={modalStyles.text}>
              თქვენი შეტყობინება გაიგზავნა წარმატებით
            </Typography>
            <Button onClick={handleModalClose} sx={modalStyles.button}>
              დახურვა
            </Button>
          </Box>
        </Box>
      )}

      {/* Modal Popup for Error */}
      {status === 'error' && (
        <Box sx={modalStyles.overlay}>
          <Box sx={modalStyles.modal}>
            <Typography sx={modalStyles.text}>
              შეცდომა! შეტყობინების გაგზავნა ვერ მოხერხდა.
            </Typography>
            <Button onClick={() => setStatus('')} sx={modalStyles.button}>
              დახურვა
            </Button>
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default MultiStepForm;
